"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var react_markdown_1 = __importDefault(require("react-markdown"));
var react_redux_1 = require("react-redux");
var PrivacyPolicyPage = function (props) {
    var _a = props;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)("PP needs to be implemented!"), privacyData = _b[0], setPrivacyData = _b[1];
    (0, react_1.useEffect)(function () {
        // user_privacy().then((response) => {
        //   if (response) {
        //     setPrivacyData(response);
        //   } else {
        //     dispatch(
        //       setMainModal({
        //         title: "Oops!", //
        //         messages: ["Sorry! We could not retrieve the privacy policy at the moment! Please try again later."],
        //       })
        //     );
        //   }
        // });
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ScreenContainerControl, { children: (0, jsx_runtime_1.jsx)(react_markdown_1.default, __assign({ className: "flex flex-col gap-4" }, { children: privacyData })) }) })));
};
exports.PrivacyPolicyPage = PrivacyPolicyPage;
